import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=3fca28c9&scoped=true"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"
import style0 from "./Professional.vue?vue&type=style&index=0&id=3fca28c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca28c9",
  null
  
)

export default component.exports